import "./libs.bundle.js";
import "./frappe/class.js";
import "./frappe/polyfill.js";
import "./frappe/provide.js";
import "./frappe/translate.js";
import "./frappe/utils/urllib.js";
import "./frappe/form/formatters.js";
import "./frappe/format.js";
import "./frappe/utils/number_format.js";
import "./frappe/utils/utils.js";
import "./frappe/utils/common.js";
import "./frappe/ui/messages.js";
import "./frappe/utils/pretty_date.js";
import "./frappe/utils/datetime.js";
import "./frappe/microtemplate.js";
import "./frappe/query_string.js";

import "./frappe/upload.js";

import "./frappe/model/meta.js";
import "./frappe/model/model.js";
import "./frappe/model/perm.js";

import "./bootstrap-4-web.bundle";

import "../../website/js/website.js";
import "./frappe/socketio_client.js";
